(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.PreferencesController = (function(superClass) {
    extend(PreferencesController, superClass);

    function PreferencesController(scope, transitions, data) {
      var ref, ref1;
      this.scope = scope;
      this.transitions = transitions;
      this.data = data;
      this.loadScopeData = bind(this.loadScopeData, this);
      this.formatKey = bind(this.formatKey, this);
      this.validJson = bind(this.validJson, this);
      this.collapseTextarea = bind(this.collapseTextarea, this);
      this.expandTextarea = bind(this.expandTextarea, this);
      this.sendTestMessage = bind(this.sendTestMessage, this);
      this.savePreferences = bind(this.savePreferences, this);
      this.scope.title = 'Preferences';
      this.scope.fullpage = true;
      this.scope.absolute_errors = true;
      this.loadScopeData(this.data.getUserPreferences(), 'preferences').then((function(_this) {
        return function() {
          var key, preference, ref, results;
          ref = _this.scope.preferences.preferences;
          results = [];
          for (key in ref) {
            preference = ref[key];
            results.push(preference.expanded = false);
          }
          return results;
        };
      })(this));
      this.scope["typeof"] = (function(_this) {
        return function(argument) {
          return typeof argument;
        };
      })(this);
      this.scope.savePreferences = this.savePreferences;
      this.scope.sendTestMessage = this.sendTestMessage;
      this.scope.expandTextarea = this.expandTextarea;
      this.scope.collapseTextarea = this.collapseTextarea;
      this.scope.formatKey = this.formatKey;
      this.scope.validJson = this.validJson;
      if ((ref = App.sidebar) != null) {
        ref.close();
      }
      if ((ref1 = App.angularSidebar) != null) {
        ref1.close();
      }
    }

    PreferencesController.prototype.savePreferences = function() {
      return this.data.saveUserPreferences(this.scope.preferences).then((function(_this) {
        return function(response) {
          if (response.data.status.type === 'error') {
            return _this.setAlert(response.data.status);
          } else {
            return _this.clearAlert();
          }
        };
      })(this));
    };

    PreferencesController.prototype.sendTestMessage = function(key) {
      return this.data.sendTestMessage(this.scope.preferences.vcs_username, key);
    };

    PreferencesController.prototype.expandTextarea = function(pref) {
      return pref.expanded = true;
    };

    PreferencesController.prototype.collapseTextarea = function(pref) {
      return pref.expanded = false;
    };

    PreferencesController.prototype.validJson = function(json) {
      var error, obj;
      try {
        obj = JSON.parse(json);
        return true;
      } catch (error1) {
        error = error1;
        return false;
      }
    };

    PreferencesController.prototype.formatKey = function(key) {
      return key.replace('_', ' ').replace(/^([a-z\u00E0-\u00FC])|\s+([a-z\u00E0-\u00FC])/g, (function(_this) {
        return function(char) {
          return char.toUpperCase();
        };
      })(this));
    };

    PreferencesController.prototype.loadScopeData = function(promise, key) {
      return promise.then((function(_this) {
        return function(response) {
          var ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            return _this.scope[key] = response.data.data;
          }
        };
      })(this));
    };

    return PreferencesController;

  })(Controller);

}).call(this);
